import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { PageSlug } from "@@/shared/pages/page-slug";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import type { ZodSchemaOf } from "@@/shared/zod-helpers";
import type { Except } from "type-fest";
import z from "zod";
import { homeZodDiscriminatedUnion } from "../provider-options";

const providerSetHomeValueZodUnion = homeZodDiscriminatedUnion.or(
    z.object({
        type: z.literal("PAGE_SLUG"),
        pageSlug: z.string() as unknown as ZodSchemaOf<PageSlug>,
    }),
);

const providerSetHomeSettingCommandZodSchema = z.object({
    _type: z.literal("PROVIDER_SET_HOME_SETTING_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    providerId: providerIdZodSchema,
    home: providerSetHomeValueZodUnion,
});

type ProviderSetHomeValue = z.infer<typeof providerSetHomeValueZodUnion>;
type ProviderSetHomeSettingCommand = z.infer<
    typeof providerSetHomeSettingCommandZodSchema
>;

type FactoryParams = Except<
    ProviderSetHomeSettingCommand,
    "_type" | "_createdAt"
>;
const providerSetHomeSettingCommandFactory = (
    params: FactoryParams,
): ProviderSetHomeSettingCommand => {
    return {
        ...params,
        _type: "PROVIDER_SET_HOME_SETTING_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
};

export {
    providerSetHomeSettingCommandFactory,
    providerSetHomeSettingCommandZodSchema,
    providerSetHomeValueZodUnion,
};
export type { ProviderSetHomeSettingCommand, ProviderSetHomeValue };
